import { action, observable, makeObservable } from 'mobx';

import { apiCaller } from '@services/apiCaller';
import { IRootStore } from '@stores/index';
import { ApiAccountDefinition } from '@api';
import { getApiErrorMessage } from '@components/common/util/util';

export interface IAccountDefinitionsListStore {
  accountDefinitions: ApiAccountDefinition[];
  firstLoad: boolean;
  getAccountDefinitions(): Promise<void>;
}

export class AccountDefinitionsListStore implements IAccountDefinitionsListStore {
  @observable public accountDefinitions: ApiAccountDefinition[] = [];

  @observable public firstLoad = false;

  @observable public rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @action.bound
  public async getAccountDefinitions() {
    try {
      const res = await apiCaller().get<{ data: ApiAccountDefinition[] }>(
        '/web/account-definitions',
      );
      this.accountDefinitions = res.data.data;
      this.firstLoad = true;
    } catch (err) {
      this.rootStore.messagesStore.showErrorMessage(
        getApiErrorMessage(err, 'Failed to fetch account definitions'),
      );
    }
  }
}
